module.exports = __webpack_public_path__ + "static/img/logo.ce6ab8fa.png";